module.exports = __webpack_public_path__ + "static/img/digitalize.5599ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/digitalize.png
// module id = e6of
// module chunks = 0